import React from "react";

const NewUI = () => {
  return <div></div>;
};

export default NewUI;
